import React from "react";
import Field from "@/components/post-ad/Field";
import AreaField from "@/components/common/AreaField";
import AddressPicker from "@/components/post-ad/AddressPicker";
import { POST } from "@/constants/testIds";

/**
 * Region → city → suburb → postcode selector plus street address picker
 * with map pin. AddressPicker's reverse-geocode is allowed to populate any
 * missing region/city/area/pincode so the buyer sees a fully-qualified
 * location on the ad detail page.
 */
export default function LocationSection({ form, set, regions, cities, isProperty = false }) {
  return (
    <>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Region">
          <select
            data-testid={POST.region}
            value={form.region}
            onChange={(e) => set({ region: e.target.value, city: "", area: "" })}
            className="input"
          >
            <option value="">Select region</option>
            {regions.map((r) => (
              <option key={r.region} value={r.region}>{r.region}</option>
            ))}
          </select>
        </Field>
        <Field label="City">
          <select
            data-testid={POST.city}
            value={form.city}
            onChange={(e) => set({ city: e.target.value, area: "" })}
            className="input"
            disabled={!cities.length}
          >
            <option value="">Select city</option>
            {cities.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </Field>
        <Field label="Suburb / Area">
          <AreaField
            testId="post-ad-area"
            region={form.region}
            city={form.city}
            country={form.country || "NZ"}
            value={form.area}
            onChange={(v) => set({ area: v })}
          />
        </Field>
        <Field label="Postcode">
          <input
            data-testid="post-ad-pincode"
            value={form.pincode}
            onChange={(e) => set({ pincode: e.target.value.replace(/[^0-9]/g, "").slice(0, 10) })}
            className="input"
            placeholder="e.g. 2023"
          />
        </Field>
      </div>

      <Field label="Street address (with map pin)">
        {/* Iter 739 — zones/commute only resolve with a street number. */}
        {isProperty && (
          <p className="mb-1.5 text-xs font-semibold text-[color:var(--brand-blue)]" data-testid="post-ad-address-helper">
            Needed for the map pin and school zones
          </p>
        )}
        <AddressPicker
          value={{ address: form.address, lat: form.lat, lng: form.lng }}
          onChange={(patch) =>
            set({
              address: patch.address ?? form.address,
              lat: patch.lat ?? form.lat,
              lng: patch.lng ?? form.lng,
              pincode: patch.pincode || form.pincode,
              area: patch.area || form.area,
              city: patch.city || form.city,
              region: patch.region || form.region,
            })
          }
        />
      </Field>
    </>
  );
}
